import "../../App.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React from "react";
import Sidebar from "../Sidebar";
import UserTab from "../UserTab";

function SubmenuReportes(props) {
  const { history, cliente } = props;
  const goTo = (path) => history.push(path);
  const base = `/Reporte/${cliente}`;

  return (
    <div className="App">
      <Sidebar tipo="3" />
      <br />
      <UserTab nombre={`Reportes ${cliente}`} />
      <div id="login">
        <div className="container">
          <div style={{ textAlign: "left", padding: "8px 16px 0" }}>
            <button
              type="button"
              onClick={() => history.push("/Reporte")}
              className="btn btn-link"
              style={{
                padding: 0,
                color: "#6B5B95",
                textDecoration: "none",
                fontSize: 13,
              }}
            >
              ← Volver a Reportes
            </button>
          </div>
          <br />
          <br />
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => goTo(`${base}/Asignacion`)}
              >
                <div className="borderSeparacion">
                  <br />
                  <i className="glyphicon glyphicon-list-alt iconSeparacion">
                    <p className="letrasSeparacion">Reporte Cambio Etapa</p>
                  </i>
                </div>
              </div>

              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => goTo(`${base}/Costas`)}
              >
                <div className="borderSeparacion">
                  <br />
                  <i className="glyphicon glyphicon-usd iconSeparacion">
                    <p className="letrasSeparacion">Reporte Costas</p>
                  </i>
                </div>
              </div>

              <div
                className="ajuste col-md-4"
                style={{ cursor: "pointer" }}
                onClick={() => goTo(`${base}/Comentario`)}
              >
                <div className="borderSeparacion">
                  <br />
                  <i className="glyphicon glyphicon-comment iconSeparacion">
                    <p className="letrasSeparacion">Reporte Comentario</p>
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(SubmenuReportes);
